<template>
  <div>
    <UApp>
      <NuxtPage />
    </UApp>
  </div>
</template>
